import { render, staticRenderFns } from "./PhaseView.vue?vue&type=template&id=d56b01de&"
import script from "./PhaseView.vue?vue&type=script&lang=js&"
export * from "./PhaseView.vue?vue&type=script&lang=js&"
import style0 from "./PhaseView.vue?vue&type=style&index=0&id=d56b01de&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports